import { render, staticRenderFns } from "./DeliveryPointValuesCard.vue?vue&type=template&id=57bd7fb6&scoped=true"
import script from "./DeliveryPointValuesCard.vue?vue&type=script&lang=js"
export * from "./DeliveryPointValuesCard.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPointValuesCard.vue?vue&type=style&index=0&id=57bd7fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bd7fb6",
  null
  
)

export default component.exports